/* Algolia検索UIをテーマの表示に合わせる（issue #115）
   Algoliaアプリの公式フックで、検索結果カードとサジェストを自前のテンプレートに差し替える。

   アプリ更新後に確認すること（アプリブロック版 92521fc3cb で確認）。
   どれも壊れるときは静かに壊れる——エラーは出ず、機能が消えるだけ。

   1. フック名（window.algoliaShopify.hooks.allowedHooks で現行の一覧が取れる）。
      使っているのは8つ: 商品カード／サジェスト商品／サジェストのオプション／
      ファセットのパラメータ／ファセットのパネル／ファセットの項目／ウィジェット追加／件数表示。
   2. 依存しているクラス名:
      .ais-facets-button（SPの絞り込みボタン。ヘッダーへ移す）
      .ais-search-header（その移動先）
      .ais-facets（スライダーとチップの監視対象）
      .ais-dropdown-checkbox（ファセットの開閉。checked＝閉じている）
      .ais-current-refined-values--link（選択中フィルターのチップ）
      .ais-results-size-xs / -sm（ボタンが出る幅。CSS側の条件）
   3. アプリが初回描画の途中でボタンを .ais-page 直下へ戻す挙動。
      戻さなくなっても実害は無いが、監視ごと外せる。
   4. 開閉ラベルが英語（Show filters / Hide filters）で書き込まれること。
      翻訳キーが増えたら、このJSのラベル置換は消してよい。
   5. 価格のレンジスライダーがrheostatであること（noUiSliderではない）。
   6. 基本色フィルターの attribute が「ファセット名＋.fields.color_taxonomy_reference」で値が出ること（issue #179）。
      アプリがメタオブジェクトの子フィールドを attribute に使うようになったら、付け足しは不要になる。

   レイアウトをもっと深く変えるなら beforeInstantSearchMainTemplate がある。
   ただしファセットの描画ループごとページの骨格を引き受けることになるため、
   ボタン1つの移動のためには採らなかった。 */
(function () {
  'use strict';

  var YEN = new Intl.NumberFormat('ja-JP');

  // 候補の「カラー／金具」の区切り。全角スラッシュは和文・中文用で、欧文では半角にする。
  var META_SEPARATOR = /^(ja|zh)/i.test(document.documentElement.lang || '') ? '／' : ' / ';

  // 外貨の税込価格をShopifyと同じく切り上げる単位。既定は1通貨単位、0は丸めない。
  // 本番の商品一覧（Dual Priceの表示）で9通貨を実測して決めた（issue #144）。
  var ROUND_UP_TO = { AED: 0, IDR: 0, PHP: 100 };

  // theme.settings.moneyFormat は表示中の通貨の書式（例: ${{amount}}、Rp {{amount_with_comma_separator}}）。
  // Impulseの theme.Currency.formatMoney と同じ置換。あちらは設定次第で<sup>を返すため使わない。
  function formatMoney(cents) {
    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || '{{amount}}';
    var withDelimiters = function (decimals, thousands, decimal) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_match, key) {
      if (key === 'amount_no_decimals') return withDelimiters(0, ',', '.');
      if (key === 'amount_with_comma_separator') return withDelimiters(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return withDelimiters(0, '.', ',');
      return withDelimiters(2, ',', '.');
    });
  }

  // 税別価格。Algoliaのpriceは「円」単位（セントではない）。
  // Dual Priceアプリの設定（dp_base_price_type=0 / dp_tax_percent=10）と同じ計算。
  // 通貨記号はテーマに合わせてU+00A5。Intlのstyle:'currency'は全角￥になるため使わない。
  // 外貨では、Shopifyが換算した税込価格を÷1.1するDual Priceと同じ順で計算する。
  function formatTaxExcluded(price) {
    var currency = window.Shopify && Shopify.currency;
    if (!currency || currency.active === 'JPY') {
      return '¥' + YEN.format(Math.round(Number(price) / 1.1));
    }
    var step = currency.active in ROUND_UP_TO ? ROUND_UP_TO[currency.active] : 1;
    var gross = Number(price) * Number(currency.rate);
    gross = step ? Math.ceil(gross / step) * step : Math.round(gross * 100) / 100;
    return formatMoney(Math.round(gross / 1.1 * 100));
  }

  // 市場ごとのインデックスは日本市場の分だけ作っている（商品はどの市場も同じで、違うのは翻訳だけ）。
  // アプリは「市場ID_言語」で探し、無ければ日本語の主インデックスに落とすため、北米などの訪問者は
  // /en/ でも日本語の結果になる。同じ言語の日本市場のエントリを今の市場用に複製して足す。
  // アプリがインデックスを決めるより前（algolia.hooks.initialize）に呼ぶこと。
  function useJapanMarketIndex() {
    var shop = window.algoliaShopify || {};
    var config = shop.config;
    var market = shop.shopify && shop.shopify.market;
    if (!config || !config.markets_indexing_enabled || !Array.isArray(config.markets_mapping) || !market) return;
    var locale = market.language && market.language.shop_locale && market.language.shop_locale.locale;
    var key = market.id + '_' + locale;
    var mapping = config.markets_mapping;
    if (mapping.some(function (entry) { return entry.key === key; })) return;
    var sameLocale = mapping.filter(function (entry) { return entry.locale === locale; })[0];
    if (sameLocale) mapping.push(Object.assign({}, sameLocale, { key: key }));
  }

  // 価格欄の分岐。product-grid-item.liquid と、その上を書き換える
  // snippets/sm-config.liquid（Dual Priceアプリ）の実際の表示に合わせる。
  function priceState(hit) {
    if (hit.template_suffix === 'ask') return { kind: 'ask', text: 'ASK' };
    if (hit.inventory_available === false) return { kind: 'sold', text: 'SOLD OUT' };
    return { kind: 'price', text: formatTaxExcluded(hit.price) };
  }

  // Shopify CDNの画像URLは既にクエリ付きなので、widthは連結して足す。
  function imageUrl(hit, width) {
    var src = hit.image || hit.product_image || '';
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // ロケール接頭辞（/en/ など）はテーマのルートから取る。Algoliaのレコードはhandleしか
  // 持たないので、/products/ を直書きすると多言語化した瞬間に全カードが日本語ページへ飛ぶ。
  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + handle;
  }

  // メタフィールドは設定されている商品にしか存在しない。
  function customMeta(hit, key) {
    return (hit.meta && hit.meta.custom && hit.meta.custom[key]) || '';
  }

  // 基本色フィルター（issue #179）の値 '["gid://shopify/TaxonomyValue/7"]' から標準カラーの ID を取る。
  var COLOR_FAMILY_FIELD = '.fields.color_taxonomy_reference';
  var COLOR_FAMILY_VALUE = /\[?"?gid:\/\/shopify\/TaxonomyValue\/(\d+)"?\]?/g;
  function colorFamilyId(value) {
    var match = /TaxonomyValue\/(\d+)/.exec(String(value || ''));
    return match ? match[1] : null;
  }
  // 並び順に無い ID は末尾（同順位内は件数の多い順）。
  function colorFamilyRank(family, value) {
    var index = family.order.indexOf(colorFamilyId(value));
    return index === -1 ? family.order.length : index;
  }
  // スウォッチの色。コレクションの基本色フィルター（#81）と同じく Shopify 標準カラーの色で、
  // ショップ側では変更できない値（本番の /collections/new-arrival で 2026-10-23 に確認）。
  // その他（2865 Multicolor）はコレクションでも色が無いので、枠だけにする。
  var COLOR_FAMILY_SWATCH = {
    1: '0 0 0', 8: '128 128 128', 3: '255 255 255', 6: '234 216 171', 7: '154 86 48', 4: '212 154 6',
    10: '255 138 0', 14: '255 229 0', 9: '5 170 61', 13: '246 31 31', 11: '255 192 203', 12: '165 77 207', 2: '0 91 211'
  };
  function colorFamilySwatch(value) {
    var rgb = COLOR_FAMILY_SWATCH[colorFamilyId(value)];
    return rgb ? 'background-color: rgb(' + rgb + ');' : '';
  }
  function colorFamilyLabel(value) {
    var labels = (window.cColorFamily && window.cColorFamily.labels) || {};
    var id = colorFamilyId(value);
    return (id && labels[id]) || null;
  }

  window.cAlgolia = { priceState: priceState, formatTaxExcluded: formatTaxExcluded };

  document.addEventListener('algolia.hooks.initialize', function () {
    useJapanMarketIndex();
    if (!window.algoliaShopify || !window.algoliaShopify.hooks) return;
    var hooks = window.algoliaShopify.hooks;

    hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      var price = priceState(hit);
      var model = customMeta(hit, 'product_model') || hit.title;
      var color = customMeta(hit, 'product_color');
      var metal = customMeta(hit, 'product_metal');
      var rank = customMeta(hit, 'product_rank');

      return html`
        <div class="grid__item-image-wrapper">
          <div class="grid-product__image-mask">
            <div class="grid__image-ratio grid__image-ratio--square">
              <img class="image-element" src=${imageUrl(hit, 540)} alt=${hit.title} loading="lazy" width="540" height="540" />
            </div>
          </div>
        </div>
        <a class="grid-product__link" href=${productUrl(hit.handle)} onClick=${function () { trackSearchAttribution(hit); }}>
          <div class="c_grid-product__meta grid-product__meta">
            <div class="grid-product__model">${model}</div>
            ${color ? html`<div class="grid-product__color">${color}</div>` : null}
            ${metal ? html`<div class="grid-product__metal">${metal}</div>` : null}
            ${rank ? html`<div class="grid-product__rank">${rank}</div>` : null}
            <div class="grid-product__price"
                 data-product-available=${hit.inventory_available === false ? 'false' : 'true'}
                 data-product-id=${String(hit.id)}
                 data-template-suffix=${hit.template_suffix || ''}>
              ${price.kind === 'sold'
                ? html`<span class="grid-product__price--sold-out" data-sold-out="true">SOLD OUT</span>`
                : price.kind === 'ask'
                  ? html`<span class="grid-product__price--ask" data-ask="true">ASK</span>`
                  : price.text}
            </div>
          </div>
        </a>`;
    });

    hooks.registerHook('beforeAutocompleteProductTemplate', function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      var item = templateOptions.item;
      var html = templateOptions.html;
      var price = priceState(item);
      var model = customMeta(item, 'product_model') || item.title;
      var color = customMeta(item, 'product_color');
      var metal = customMeta(item, 'product_metal');

      return html`
        <a class="c_algolia-suggestion" href=${productUrl(item.handle)} onClick=${function () { trackSearchAttribution(item); }}>
          <img class="c_algolia-suggestion__image" src=${imageUrl(item, 120)} alt=${item.title} loading="lazy" width="60" height="60" />
          <span class="c_algolia-suggestion__text">
            <span class="c_algolia-suggestion__model">${model}</span>
            <span class="c_algolia-suggestion__meta">${[color, metal].filter(Boolean).join(META_SEPARATOR)}</span>
          </span>
          <span class="c_algolia-suggestion__price">${price.text}</span>
        </a>`;
    });

    // パネル幅はインラインスタイルで入力欄に合わせられるため、CSSでは上書きできない。
    // Algolia側のオプションで全幅配置に変える（issue #115 P2）。
    hooks.registerHook('beforeAutocompleteOptions', function (options) {
      options.panelPlacement = 'full-width';

      // アプリはヘッダーの入力欄のplaceholderを空のままにする。結果ページと同じ文言にそろえる。
      var translations = (window.algoliaShopify && window.algoliaShopify.translations) || {};
      if (translations.searchForProduct) {
        options.placeholder = translations.searchForProduct;
      }

      // サジェストは商品だけ。コレクションは探さなくても見つかる（お客様の要望）。
      var collectionsPlugin = window.algoliaShopify && window.algoliaShopify.collectionsPlugin;
      if (collectionsPlugin && Array.isArray(options.plugins)) {
        options.plugins = options.plugins.filter(function (plugin) {
          return plugin !== collectionsPlugin;
        });
      }

      // キーボードで選んでEnterを押しても遷移しない（パネルが閉じるだけ）。
      // アプリのproductsソースは sourceId / getItems / templates しか持たず、
      // getItemUrl が無いためAutocompleteが遷移先を知らない。ソースに足す。
      if (Array.isArray(options.plugins)) {
        var withItemUrl = function (sources) {
          return (sources || []).map(function (source) {
            if (!source || source.sourceId !== 'products' || source.getItemUrl) return source;
            var patched = Object.assign({}, source);
            patched.getItemUrl = function (args) {
              var item = args && args.item;
              return item && item.handle ? productUrl(item.handle) : undefined;
            };
            return patched;
          });
        };
        options.plugins = options.plugins.map(function (plugin) {
          if (!plugin || typeof plugin.getSources !== 'function') return plugin;
          return Object.assign({}, plugin, {
            getSources: function (params) {
              var sources = plugin.getSources(params);
              return sources && typeof sources.then === 'function'
                ? sources.then(withItemUrl)
                : withItemUrl(sources);
            }
          });
        });
      }

      return options;
    });

    // 基本色フィルター（shopify.color-pattern、issue #179）。コレクションの基本色フィルター（#81）と同じ13系統＋その他にする。
    // アプリには「メタオブジェクト参照」として Base color（color_taxonomy_reference）だけをインデックスさせている。
    // レコードでは meta.shopify.color-pattern が [{ _id, fields: { color_taxonomy_reference: '["gid://shopify/TaxonomyValue/7"]' } }]
    // になり、ファセット値になるのは子の fields.color_taxonomy_reference の方。アプリはファセット名（親）をそのまま
    // attribute にするため、親のままでは値が1つも返らない（Devで実測）。
    // 値は言語に関係なく Shopify 標準カラーの ID なので、並び順とラベルはコレクションと同じもの
    // （snippets/c_color-family-order と locales の sections.c_color_family、theme.liquid が window.cColorFamily で渡す）を使う。
    // transformItems のフック（beforeInstantSearchFacetTransformItemsOptions）はアプリ側で非推奨になっており、
    // ファセット名も受け取れないため、params の transformItems を包む。
    var isColorFamilyFacet = function (facet) {
      return Boolean(facet && String(facet.name || '').indexOf('color-pattern') !== -1);
    };
    var colorFamilyParams = function (params, facet) {
      var family = window.cColorFamily || { order: [], labels: {} };
      if (String(facet.name).indexOf(COLOR_FAMILY_FIELD) === -1) {
        params.attribute = facet.name + COLOR_FAMILY_FIELD;
        // 選択中フィルターのチップは、ファセット一覧から name === attribute で見出しを探す。
        // 見つからないと描画ごと止まる（件数も商品も更新されない）ため、ファセット側の name も揃える。
        // この facet はアプリのファセット一覧と同じオブジェクト（Devで確認）。
        // 元の名前は、値が無いときに枠を隠す処理（beforeInstantSearchFacetPanelOptions）で使う。
        facet.cAlgoliaOriginalName = facet.name;
        facet.name = params.attribute;
      }
      params.limit = Math.max(params.limit || 0, family.order.length);
      params.sortBy = function (a, b) {
        return colorFamilyRank(family, a.name) - colorFamilyRank(family, b.name) || b.count - a.count;
      };
      var appTransformItems = params.transformItems;
      params.transformItems = function (items) {
        var mapped = typeof appTransformItems === 'function' ? appTransformItems(items) : items;
        return mapped.map(function (item) {
          var label = colorFamilyLabel(item.value);
          return label ? Object.assign({}, item, { label: label, highlighted: label }) : item;
        });
      };
      return params;
    };

    // 価格スライダーは既定で生の数値を出す。テーマと同じ税別・¥表記に合わせる（issue #115）
    // pipsはfalse: 目盛りは出さず、Prodと同じくスライダー上のmin/max行だけを見せる（ensurePriceRangeが作る）。
    // 基本色はコレクションと同じスウォッチ（四角の色＋ラベル）で出す（issue #179、お客様のご希望）。
    // 構造はアプリ既定の項目テンプレートと同じ（label > checkbox ＋ ラベル ＋ 件数）で、色の四角を足すだけ。
    // クリックの処理はアプリ（InstantSearch）側が label/checkbox で行うため、checkbox は消さずに見た目だけ隠す（CSS）。
    hooks.registerHook('beforeInstantSearchFacetItemTemplate', function (defaultTemplate, item, html) {
      if (!item || String(item.attribute || '').indexOf(COLOR_FAMILY_FIELD) === -1) return defaultTemplate;
      var classes = item.cssClasses || {};
      var shop = window.algoliaShopify;
      return html`
        <label class="${classes.label} c_algolia-swatch-item${item.isRefined ? ' c_algolia-swatch-item--active' : ''}">
          ${item.isRefined
            ? html`<input type="checkbox" class="${classes.checkbox}" checked />`
            : html`<input type="checkbox" class="${classes.checkbox}" />`}
          <span class="color-swatch color-swatch--filter c_algolia-swatch${colorFamilyId(item.value) === '3' ? ' c_algolia-swatch--white' : ''}" style="${colorFamilySwatch(item.value)}" aria-hidden="true"></span>
          <span class="c_algolia-swatch-item__label">${item.label}</span>
          <span class="${classes.count}">${shop.helpers.formatNumber(item.count)}</span>
        </label>
      `;
    });

    // 値が1つも無い検索（例: twilly）では、アプリが枠（.ais-facet-<ファセット名>）ごと隠す。
    // 基本色は facet.name を書き換えたため既定の処理では枠が見つからず、見出しだけ残る（Devで確認）。
    // 既定と同じ処理を、元の名前の枠に対して行う。
    hooks.registerHook('beforeInstantSearchFacetPanelOptions', function (options, facet) {
      if (!isColorFamilyFacet(facet) || !facet.cAlgoliaOriginalName) return options;
      var selector = '.ais-facet-' + encodeURIComponent(facet.cAlgoliaOriginalName).replace(/\./g, '\\.').replace(/%/g, '\\%');
      options.hidden = function (renderOptions) {
        var hide = !renderOptions.canRefine;
        var wrapper = document.querySelector(selector);
        if (wrapper) wrapper.style.display = hide ? 'none' : '';
        return hide;
      };
      return options;
    });

    hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
      if (isColorFamilyFacet(facet)) return colorFamilyParams(params, facet);
      if (!facet || facet.type !== 'slider') return params;
      params.pips = false;
      params.tooltips = { format: function (value) { return formatTaxExcluded(value); } };
      return params;
    });

    // 検索結果ページのタイトルはアプリ既定だと言語に関わらず英語になる（初回表示は
    // Liquidのタイトルで正しく、検索窓に入力した瞬間にアプリが英語で上書きする）。
    // タイトル用のフックは無い（allowedHooksの56個を確認済み）。Templateフックは
    // テンプレートを返すためのもので、副作用の置き場ではないので、描画ごとに走る
    // 自前のInstantSearchウィジェットを足す——これがアプリの用意した拡張点。
    // renderはresultsを直接受け取るので、URLのqとの照合も引数の当てずっぽうも要らない。
    var searchPageTitle = function (query, nbHits) {
      var lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.indexOf('zh-tw') === 0) return '搜尋:「' + query + '」搜尋結果' + nbHits;
      if (lang.indexOf('ja') === 0) return '検索: 「' + query + '」の検索結果' + nbHits + '件';
      if (lang.indexOf('id') === 0) return 'Cari: ' + nbHits + ' hasil untuk "' + query + '"';
      return 'Search: ' + nbHits + ' results for "' + query + '"';
    };

    hooks.registerHook('beforeInstantSearchStartAddWidgets', function (widgets) {
      var titleWidget = {
        render: function (renderOptions) {
          var results = renderOptions && renderOptions.results;
          if (!results || typeof results.nbHits === 'undefined') return;
          document.title = searchPageTitle(results.query || '', results.nbHits);
        }
      };
      return (Array.isArray(widgets) ? widgets : []).concat([titleWidget]);
    });

    // 件数の後ろの検索時間（「／ 0.001s」「in 0.001s」）はProdの検索結果に無いので出さない。
    // アプリ既定のテンプレートから translation_helpers.in(processingTimeMS) を除いただけの形。
    hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
      var shop = window.algoliaShopify;
      var t = shop.translations;
      return html`
        <span>
          ${data.hasNoResults && t.noResultFound}
          ${data.hasOneResult && html`<span class="ais-stats--nb-results">${t.oneResultFound}</span>`}
          ${data.hasManyResults && html`
            ${shop.translation_helpers.outOf(data.page, data.hitsPerPage, data.nbHits)}
            <span class="ais-stats--nb-results">
              ${' '} ${shop.helpers.formatNumber(data.nbHits)} ${' '}
              ${t.resultsFound}
            </span>
          `}
        </span>
      `;
    });

    // rheostatの目盛りとSelected filtersのチップは生の数値を出すため、描画後に整形する（issue #115）
    var formatNumbers = function (root) {
      var labels = root.querySelectorAll('.rheostat-marker, .rheostat-value, .ais-current-refined-values--link');
      for (var i = 0; i < labels.length; i++) {
        var el = labels[i];
        var raw = (el.textContent || '').trim();
        if (/^\d+$/.test(raw)) {
          el.textContent = formatTaxExcluded(raw); // 目盛り（数値のみ）
        } else if (/\d{4,}/.test(raw)) {
          el.textContent = raw.replace(/\d{4,}/g, function (n) { return formatTaxExcluded(n); }); // チップ
        }
      }
    };
    // Prodと同じく、値はスライダーの上に min / max の1行で出す（issue #115）
    var ensurePriceRange = function (root) {
      var slider = root.querySelector('.rheostat');
      if (!slider) return;
      var lower = slider.querySelector('.rheostat-handle-lower');
      var upper = slider.querySelector('.rheostat-handle-upper');
      if (!lower || !upper) return;
      var host = slider.parentElement;
      var row = host.querySelector('.c_algolia-price-range');
      if (!row) {
        row = document.createElement('div');
        row.className = 'c_algolia-price-range';
        row.appendChild(document.createElement('span'));
        row.appendChild(document.createElement('span'));
        host.insertBefore(row, slider);
      }
      var min = formatTaxExcluded(lower.getAttribute('aria-valuenow'));
      var max = formatTaxExcluded(upper.getAttribute('aria-valuenow'));
      // 同じ値を書き直すとMutationObserverが自分自身で発火し続けるため、差分があるときだけ書く
      if (row.firstChild.textContent !== min) row.firstChild.textContent = min;
      if (row.lastChild.textContent !== max) row.lastChild.textContent = max;
    };

    // ---- 描画後のDOM調整 -------------------------------------------------
    // アプリは初回描画の途中でノードを作り直す／置き直す（絞り込みボタンも .ais-facets も
    // 実測で確認）。initialize時点のノードに監視を張っても外れるので、bodyに監視を1本だけ
    // 置き、そのつど「いまのDOM」に当て直す。処理はすべて冪等で、差分があるときしか書かない。

    // Prodのフィルターは閉じた状態で始まる（main-collection.liquidのsection.settings.collapsed）。
    // ファセットは label＋隠しcheckbox＋コンテナのアコーディオンで、checked＝閉じている。
    // ユーザーが開いたものを再描画で閉じ直さないよう、印を付けて1回だけ閉じる。
    var collapseFacets = function (root) {
      var boxes = root.querySelectorAll('.ais-dropdown-checkbox');
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].getAttribute('data-c-algolia-collapsed') === '1') continue;
        boxes[i].setAttribute('data-c-algolia-collapsed', '1');
        boxes[i].checked = true;
      }
    };

    // SPではProdの .collection-filter と同じく絞り込みと並び替えを1行に並べる。
    // アプリは絞り込みボタンを .ais-page 直下、並び替えを .ais-search-header の中に置くため
    // CSSだけでは横に並ばない。ボタンをヘッダーへ移す（並べるのはCSS側）。
    // PCではボタンが display:none のままなので、この移動は見た目に影響しない。
    // 開閉ラベルはアプリがJSで英語を直接書き込む。translationsに該当キーは無く
    // （アプリが未知キーを捨てる）、開閉を表すクラスも付かないためCSSでも差し替えられない。
    // 開いたときのラベルは短く。ボタンは48%幅・高さ44px固定で、長い語は収まらない。
    // 言語の判定はページタイトルと同じく <html lang>。
    var FACETS_BUTTON_LABELS = (function () {
      var lang = (document.documentElement.lang || '').toLowerCase();
      if (lang.indexOf('zh-tw') === 0) return { 'Show filters': '篩選', 'Hide filters': '關閉' };
      if (lang.indexOf('ja') === 0) return { 'Show filters': '絞り込み', 'Hide filters': '閉じる' };
      if (lang.indexOf('id') === 0) return { 'Show filters': 'Filter', 'Hide filters': 'Tutup' };
      return { 'Show filters': 'Filter', 'Hide filters': 'Close' };
    })();
    var wireFacetsButton = function () {
      var button = document.querySelector('.ais-facets-button');
      var header = document.querySelector('.ais-search-header');
      if (!button || !header) return;

      if (button.parentElement !== header) {
        header.insertBefore(button, header.firstChild);
      }

      if (button.getAttribute('data-c-algolia-label') === '1') return;
      button.setAttribute('data-c-algolia-label', '1');

      var localize = function () {
        var label = FACETS_BUTTON_LABELS[(button.textContent || '').trim()];
        if (label) button.textContent = label;
      };
      // 自分の書き換えで再発火しないよう、書く間だけ監視を外す
      var labelObserver = new MutationObserver(function () {
        labelObserver.disconnect();
        localize();
        labelObserver.observe(button, { childList: true, subtree: true, characterData: true });
      });
      localize();
      labelObserver.observe(button, { childList: true, subtree: true, characterData: true });
    };

    // 1つでも失敗したら残りも止まる、を避ける。原因はwindow.cAlgolia.lastErrorに残す。
    // 「選択中のフィルター」の見出しはtranslationsのselectedFilterを使わず英語のまま出る。
    var localizeRefinedHeader = function (root) {
      var header = root.querySelector('.ais-current-refined-values--header');
      if (!header) return;
      var label = ((window.algoliaShopify && window.algoliaShopify.translations) || {}).selectedFilter;
      if (label && header.textContent.trim() !== label) header.textContent = label;
    };

    // 選択中フィルターのチップは基本色の値（'["gid://shopify/TaxonomyValue/7"]'）をそのまま出すため、
    // 一覧と同じ自社ラベルに置き換える（#81 のコレクションのチップと同じ問題、issue #179）。
    // formatNumbers より先に通すこと（ID の4桁、例えば 2865 を価格として整形してしまう）。
    var localizeColorChips = function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue;
        if (text.indexOf('TaxonomyValue/') === -1) continue;
        var replaced = text.replace(COLOR_FAMILY_VALUE, function (value) {
          return colorFamilyLabel(value) || value;
        });
        if (replaced !== text) node.nodeValue = replaced;
      }
    };

    var applyDomTweaks = function () {
      var steps = [
        ['button', function () { wireFacetsButton(); }],
        ['facets', function () {
          var facetsRoot = document.querySelector('.ais-facets');
          if (!facetsRoot) return;
          localizeColorChips(facetsRoot);
          formatNumbers(facetsRoot);
          ensurePriceRange(facetsRoot);
          collapseFacets(facetsRoot);
          localizeRefinedHeader(facetsRoot);
        }]
      ];
      for (var i = 0; i < steps.length; i++) {
        try {
          steps[i][1]();
        } catch (error) {
          window.cAlgolia.lastError = steps[i][0] + ': ' + (error && error.message);
        }
      }
    };

    // 描画1回につき1度で足りるのでまとめる。requestAnimationFrameは使わない——
    // バックグラウンドのタブでは発火せず、そのまま二度と当たらなくなる（実測）。
    var applyScheduled = false;
    var scheduleDomTweaks = function () {
      if (applyScheduled) return;
      applyScheduled = true;
      setTimeout(function () {
        applyScheduled = false;
        applyDomTweaks();
      }, 50);
    };

    // ヘッダーの検索ドロワーが閉じられない。テーマの <predictive-search> は
    // data-enabled="false"（検索をアプリが肩代わりしている）で早期returnし、
    // Esc・オーバーレイ・閉じるボタン・開いたときのフォーカス移動をすべて飛ばす。
    // 開く側は別経路なので開く。閉じるボタン自体もアプリがフォームごと置き換えるため
    // 残っていない。要素のclose()は生きているので、そこへ配線し直す。
    // ここは描画のたびではなく一度だけ実行する（リスナーの二重登録を避ける）。
    var headerSearch = document.querySelector('predictive-search[data-context="header"]');
    var searchContainer = document.querySelector('.site-header__search-container');
    if (headerSearch && searchContainer && typeof headerSearch.close === 'function') {
      var searchIsOpen = function () {
        return searchContainer.classList.contains('is-active');
      };
      var closeHeaderSearch = function () {
        if (searchIsOpen()) headerSearch.close();
      };
      // 開くアニメーションの途中では隠れた要素にフォーカスできないので、開くまで待つ
      var focusSearchInput = function (attempt) {
        attempt = attempt || 0;
        if (searchIsOpen()) {
          var field = document.querySelector('.site-header__search .aa-Input') ||
            document.querySelector('.site-header__search .aa-DetachedSearchButton');
          if (field) {
            field.focus();
            return;
          }
        }
        if (attempt < 12) {
          setTimeout(function () { focusSearchInput(attempt + 1); }, 80);
        }
      };

      // アプリの検索候補は、条件に合うフォームのうち表示中の最初の1つにだけ付き、選び直すのは
      // resizeのとき（150ms待つ）だけ。トップページではページ内の検索欄が選ばれ、ヘッダーには
      // 候補が出ない。開閉のたびにresizeを送って選び直させる。フォームが1つのページでは何も起きない。
      // 閉じた直後は is-transitioning（display:block !important）でまだ表示扱い。Impulseはこのクラスを
      // transitionendでしか外さず、SP幅では発火せずに残る（画面外なので見えないが、アプリは表示中と判定する）。
      // 閉じたら400ms待ち、残っていれば外してから送る。
      var wasOpen = searchIsOpen();
      var settleTimer = null;
      new MutationObserver(function () {
        var open = searchIsOpen();
        if (open === wasOpen) return;
        wasOpen = open;
        clearTimeout(settleTimer);
        if (open) {
          window.dispatchEvent(new Event('resize'));
          return;
        }
        settleTimer = setTimeout(function () {
          if (!searchIsOpen()) searchContainer.classList.remove('is-transitioning');
          window.dispatchEvent(new Event('resize'));
        }, 400);
      }).observe(searchContainer, { attributes: true, attributeFilter: ['class'] });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) closeHeaderSearch();
      });

      var screen = headerSearch.querySelector('.predictive__screen');
      if (screen) screen.addEventListener('click', closeHeaderSearch);

      // 虫眼鏡: 開いていれば閉じる、閉じていればテーマに開かせてから入力欄へフォーカス。
      // テーマのハンドラはボタン自身に付いていて必ず開くので、documentのキャプチャ段階で
      // 先に捕まえる（同じ要素上ではcapture/bubbleの順序は変わらないため）。
      document.addEventListener('click', function (event) {
        var toggle = event.target && event.target.closest && event.target.closest('.js-search-header');
        if (!toggle) return;
        if (searchIsOpen()) {
          event.preventDefault();
          event.stopPropagation();
          closeHeaderSearch();
          return;
        }
        focusSearchInput(0);
      }, true);
    }

    // 選択中フィルターの欄（見出しとチップ）はアプリが選択のたびに作り直す（見出しは英語、チップは元の値）。
    // まとめた後処理（50ms後）では一瞬元の表示が見えるため、この欄だけは監視のコールバック内（描画の前）で
    // 置き換える。どちらも差分があるときしか書かないので、自分の書き換えで繰り返すことはない。
    var localizeRefinedNow = function () {
      var refined = document.querySelector('.ais-current-refined-values-container');
      if (!refined) return;
      try {
        localizeRefinedHeader(refined);
        if (refined.textContent.indexOf('TaxonomyValue/') !== -1) localizeColorChips(refined);
      } catch (error) {
        window.cAlgolia.lastError = 'refined: ' + (error && error.message);
      }
    };

    applyDomTweaks();
    new MutationObserver(function () {
      localizeRefinedNow();
      scheduleDomTweaks();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
